// A SYNCHRONOUS hint that this browser probably has a signed-in session.
//
// WHY IT EXISTS. The App Shell Performance Pass made "/" render <LandingPage />
// optimistically and redirect from an effect once Firebase Auth answers, on the
// reasoning that a genuine marketing visitor must never wait on an auth round
// trip. That is still right — and it left a deliberate tradeoff: an ALREADY
// SIGNED-IN person who opens "/" sees the marketing page flash for ~300ms
// before the bounce to /dashboard.
//
// The flash is unavoidable while the only source of "is this person signed in"
// is asynchronous. This is a synchronous one. It is a HINT, never an authority:
//
//   • It never grants access to anything. Firebase Auth remains the only thing
//     that decides who is signed in; this only decides whether "/" paints
//     marketing copy or a spinner for the few hundred ms before auth answers.
//   • It is allowed to be wrong. A stale hint (session expired, cleared
//     server-side, signed out in another tab) costs one spinner, after which
//     RootRoute falls through to the landing page and the hint is cleared.
//   • Forging it gains nothing — the worst a tampered value can do is show its
//     own browser a spinner instead of a marketing page.
//
// Every access is wrapped: localStorage throws (not returns null) when storage
// is disabled or in some Safari private-mode configurations, and RootRoute is
// the app's entry route — an unguarded throw there is a white screen for
// everyone. A browser that can't store this simply keeps the old behavior.

const SESSION_HINT_KEY = 'bf_hadSession';

export function hasSessionHint() {
  try {
    return localStorage.getItem(SESSION_HINT_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function markSessionHint() {
  try {
    localStorage.setItem(SESSION_HINT_KEY, '1');
  } catch (e) { /* storage unavailable — degrade to the pre-hint behavior */ }
}

export function clearSessionHint() {
  try {
    localStorage.removeItem(SESSION_HINT_KEY);
  } catch (e) { /* nothing to do — see above */ }
}
